import React from 'react'

interface IUserDetails {
  id?: string | null;
}

const UserDetail = ({ id }: IUserDetails) => {
  return (
    <div>UserDetail</div>
  )
}

export default UserDetail